import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 0;\n  margin: 0;\n\n  border: none;\n  ", "\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    border-", "-width: 1px;\n    border-", "-style: solid;\n    border-", "-color: var(", ");\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
/**
 * Mixin that provides a set of unified border styles for usage in various
 * components that require visual dividers
 *
 * @param {LogicalOrientation} orientation
 */

export function injectDividerBorderStyle(orientation) {
  return css(_templateObject(), orientation, orientation, orientation, function (props) {
    return props.theme.colors.ui.divider;
  });
}
export var StyledDivider = styled.hr(_templateObject2(), injectDividerBorderStyle('block-start'), injectSpacing('margin'));